import { ArrowUpRight, Phone, Zap } from "lucide-react";
import { CONTACT } from "@/lib/data";

const Masked = ({ children, delay }) => (
  <span className="block overflow-hidden">
    <span
      className="block"
      style={{ animation: `lld-rise 0.65s cubic-bezier(0.16,1,0.3,1) ${delay}s both` }}
    >
      {children}
    </span>
  </span>
);

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative min-h-[72vh] sm:min-h-[85vh] lg:min-h-screen flex flex-col justify-start lg:justify-center overflow-hidden grid-bg"
    >
      {/* navy gradient base */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(130% 90% at 78% -10%, #163e73 0%, #0c2038 42%, #0a1526 100%)" }}
      />
      {/* glow */}
      <div className="absolute top-[-10%] right-[-5%] h-[600px] w-[600px] rounded-full bg-[#2f80ed]/25 blur-[150px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 h-[400px] w-[400px] rounded-full bg-[#38bdf8]/10 blur-[120px] pointer-events-none" />

      <div className="relative z-10 w-full max-w-[1500px] mx-auto px-6 lg:px-10 pt-28 pb-12 sm:pt-36 sm:pb-16 lg:py-28 flex flex-col items-center text-center">
        <div className="flex items-center justify-center gap-3 mb-6 animate-fade-up" style={{ animationDelay: "0.05s" }}>
          <Zap className="h-4 w-4 text-[#38bdf8]" />
          <span className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.25em] text-white/50">
            Link-Lite Data LLC · Eastern Pennsylvania
          </span>
        </div>

        <h1
          className="font-display font-bold tracking-tight leading-[1.1] sm:whitespace-nowrap"
          style={{ fontSize: "clamp(1.9rem, 4.1vw, 4rem)" }}
        >
          <Masked delay={0.1}>
            Keeping your business &amp; home <span className="text-[#3B82F6] text-glow">connected.</span>
          </Masked>
        </h1>

        <p
          className="mt-8 max-w-2xl text-white/65 text-base sm:text-lg leading-relaxed animate-fade-up"
          style={{ animationDelay: "0.16s" }}
        >
          Network &amp; VOIP, CCTV security, custom websites and complete IT for Eastern PA homes and
          businesses — plus turnkey software platforms you can launch as your own.
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4 w-full sm:w-auto animate-fade-up"
          style={{ animationDelay: "0.24s" }}
        >
          <a
            href="#request"
            data-testid="hero-get-help-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#2f80ed] px-8 py-4 font-semibold text-white hover:bg-[#4a9bff] transition-colors w-full sm:w-auto"
          >
            Get Help Now
            <ArrowUpRight className="h-5 w-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
          <a
            href={CONTACT.phoneHref}
            data-testid="hero-call-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-8 py-4 font-semibold hover:border-white/40 transition-colors w-full sm:w-auto"
          >
            <Phone className="h-4 w-4" /> Call / Text
          </a>
        </div>
      </div>
    </section>
  );
};
